export const UserLoginConstant = {
    API: 'Login'
}

export const UserLoginAPIConstant = {
    CHECKUSEREXISTS: `${UserLoginConstant.API}/CheckUserExists`,
    AUTHORIZELOGGEDINUSER: `${UserLoginConstant.API}/AuthorizeLoggedInUser`
}